import * as React from "react";
import dynamic from "next/dynamic";

import type { B01Props } from "@stadium/shared/src/components/plasmic/B01";
import type { B02Props, SlideItem } from "@stadium/shared/src/components/plasmic/B02";
import type { B02bProps } from "@stadium/shared/src/components/plasmic/B02b";
import type { B03Props } from "@stadium/shared/src/components/plasmic/B03";
import type { B04Props } from "@stadium/shared/src/components/plasmic/B04";
import type { B05Props } from "@stadium/shared/src/components/plasmic/B05";
import type { B06Props } from "@stadium/shared/src/components/plasmic/B06";
import type { B07Props } from "@stadium/shared/src/components/plasmic/B07";
import type { B08Props } from "@stadium/shared/src/components/plasmic/B08";
import type { B09Props } from "@stadium/shared/src/components/plasmic/B09";
import type { B10Props } from "@stadium/shared/src/components/plasmic/B10";
import type { B12Props } from "@stadium/shared/src/components/plasmic/B12";
import type { B13Props } from "@stadium/shared/src/components/plasmic/B13";
import type { B14Props } from "@stadium/shared/src/components/plasmic/B14";
import type { B15Props } from "@stadium/shared/src/components/plasmic/B15";
import type { B16Props } from "@stadium/shared/src/components/plasmic/B16";
import type { B17Props } from "@stadium/shared/src/components/plasmic/B17";
import type { B18Props } from "@stadium/shared/src/components/plasmic/B18";
import type { B19Props } from "@stadium/shared/src/components/plasmic/B19";
import type { B20Props } from "@stadium/shared/src/components/plasmic/B20";
import type { B21Props } from "@stadium/shared/src/components/plasmic/B21";
import type { B22Props } from "@stadium/shared/src/components/plasmic/B22";
import type { B23Props } from "@stadium/shared/src/components/plasmic/B23";

const B01 = dynamic<B01Props>(() =>
  import("@stadium/shared/src/components/plasmic/B01").then((mod) => mod.default),
);
const B02 = dynamic<B02Props>(() =>
  import("@stadium/shared/src/components/plasmic/B02").then((mod) => mod.default),
);
const B02b = dynamic<B02bProps>(() =>
  import("@stadium/shared/src/components/plasmic/B02b").then((mod) => mod.default),
);
const B03 = dynamic<B03Props>(() =>
  import("@stadium/shared/src/components/plasmic/B03").then((mod) => mod.default),
);
const B04 = dynamic<B04Props>(() =>
  import("@stadium/shared/src/components/plasmic/B04").then((mod) => mod.default),
);
const B05 = dynamic<B05Props>(() =>
  import("@stadium/shared/src/components/plasmic/B05").then((mod) => mod.default),
);
const B06 = dynamic<B06Props>(() =>
  import("@stadium/shared/src/components/plasmic/B06").then((mod) => mod.default),
);
const B07 = dynamic<B07Props>(() =>
  import("@stadium/shared/src/components/plasmic/B07").then((mod) => mod.default),
);
const B08 = dynamic<B08Props>(() =>
  import("@stadium/shared/src/components/plasmic/B08").then((mod) => mod.default),
);
const B09 = dynamic<B09Props>(() =>
  import("@stadium/shared/src/components/plasmic/B09").then((mod) => mod.default),
);
const B10 = dynamic<B10Props>(() =>
  import("@stadium/shared/src/components/plasmic/B10").then((mod) => mod.default),
);
const B12 = dynamic<B12Props>(() =>
  import("@stadium/shared/src/components/plasmic/B12").then((mod) => mod.default),
);
const B13 = dynamic<B13Props>(() =>
  import("@stadium/shared/src/components/plasmic/B13").then((mod) => mod.default),
);
const B14 = dynamic<B14Props>(() =>
  import("@stadium/shared/src/components/plasmic/B14").then((mod) => mod.default),
);
const B15 = dynamic<B15Props>(() =>
  import("@stadium/shared/src/components/plasmic/B15").then((mod) => mod.default),
);
const B16 = dynamic<B16Props>(() =>
  import("@stadium/shared/src/components/plasmic/B16").then((mod) => mod.default),
);
const B17 = dynamic<B17Props>(() =>
  import("@stadium/shared/src/components/plasmic/B17").then((mod) => mod.default),
);
const B18 = dynamic<B18Props>(() =>
  import("@stadium/shared/src/components/plasmic/B18").then((mod) => mod.default),
);
const B19 = dynamic<B19Props>(() =>
  import("@stadium/shared/src/components/plasmic/B19").then((mod) => mod.default),
);
const B20 = dynamic<B20Props>(() =>
  import("@stadium/shared/src/components/plasmic/B20").then((mod) => mod.default),
);
const B21 = dynamic<B21Props>(() =>
  import("@stadium/shared/src/components/plasmic/B21").then((mod) => mod.default),
);
const B22 = dynamic<B22Props>(() =>
  import("@stadium/shared/src/components/plasmic/B22").then((mod) => mod.default),
);
const B23 = dynamic<B23Props>(() =>
  import("@stadium/shared/src/components/plasmic/B23").then((mod) => mod.default),
);

import {
  BannerVariant,
  B_01,
  B_02,
  B_02b,
  B_03,
  B_04,
  B_05,
  B_06,
  B_07,
  B_08,
  B_09,
  B_10,
  B_12,
  B_13,
  B_14,
  B_15,
  B_16,
  B_17,
  B_18,
  B_19,
  B_20,
  B_21,
  B_22,
  B_23,
  B01ListItem,
  B05BulletPoint,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

import type { LinkRouteDefaults } from "@stadium/shared/src/components/link-with-lang";
// Individual Banner component props with prefixed names for Banner wrapper
export interface B01BannerProps {
  heading?: B01Props["heading"];
  primaryButtonText?: B01Props["primaryButtonText"];
  primaryButtonUrl?: B01Props["primaryButtonUrl"];
  secondaryButtonText?: B01Props["secondaryButtonText"];
  secondaryButtonUrl?: B01Props["secondaryButtonUrl"];
  mobileImg?: B01Props["mobileImg"];
  desktopImg?: B01Props["desktopImg"];
  imageAlt?: B01Props["imageAlt"];
  listItems?: B01ListItem[];
}

export interface B02BannerProps {
  b02Slides?: SlideItem[];
  sectionHeading?: B02Props["sectionHeading"];
}

export interface B02bBannerProps {
  slides?: B02bProps["slides"];
}

export interface B03BannerProps {
  b03EyebrowText?: B03Props["eyebrowText"];
  b03Heading?: B03Props["heading"];
  b03Features?: B03Props["features"];
  b03CtaText?: B03Props["ctaText"];
  b03CtaLinkType?: B03Props["ctaLinkType"];
  b03CtaOpenInNewTab?: B03Props["ctaOpenInNewTab"];
  b03CtaOtherUrl?: B03Props["ctaOtherUrl"];
  b03CtaCategorySlug?: B03Props["ctaCategorySlug"];
}

export interface B04BannerProps {
  b04Eyebrow?: B04Props["eyebrow"];
  b04Heading?: B04Props["heading"];
  b04Description?: B04Props["description"];
  b04ButtonText?: B04Props["buttonText"];
  b04ButtonLinkType?: B04Props["buttonLinkType"];
  b04ButtonOpenInNewTab?: B04Props["buttonOpenInNewTab"];
  b04ButtonOtherUrl?: B04Props["buttonOtherUrl"];
  b04ButtonCategorySlug?: B04Props["buttonCategorySlug"];
  b04MobileImg?: B04Props["mobileImg"];
  b04DesktopImg?: B04Props["desktopImg"];
  b04ImageAlt?: B04Props["imageAlt"];
  b04OverlayOpacity?: B04Props["overlayOpacity"];
}

export interface B05BannerProps {
  b05Heading?: B05Props["heading"];
  b05Description?: B05Props["description"];
  b05BulletPoints?: B05BulletPoint[];
  b05PrimaryButtonText?: B05Props["primaryButtonText"];
  b05PrimaryButtonLinkType?: B05Props["primaryButtonLinkType"];
  b05PrimaryButtonOpenInNewTab?: B05Props["primaryButtonOpenInNewTab"];
  b05PrimaryButtonOtherUrl?: B05Props["primaryButtonOtherUrl"];
  b05PrimaryButtonCategorySlug?: B05Props["primaryButtonCategorySlug"];
  b05SecondaryButtonText?: B05Props["secondaryButtonText"];
  b05SecondaryButtonLinkType?: B05Props["secondaryButtonLinkType"];
  b05SecondaryButtonOpenInNewTab?: B05Props["secondaryButtonOpenInNewTab"];
  b05SecondaryButtonOtherUrl?: B05Props["secondaryButtonOtherUrl"];
  b05SecondaryButtonCategorySlug?: B05Props["secondaryButtonCategorySlug"];
  b05MobileImg?: B05Props["mobileImg"];
  b05DesktopImg?: B05Props["desktopImg"];
  b05ImageAlt?: B05Props["imageAlt"];
  b05OverlayOpacity?: B05Props["overlayOpacity"];
}

export interface B06BannerProps {
  b06Eyebrow?: B06Props["eyebrow"];
  b06Heading?: B06Props["heading"];
  b06Description?: B06Props["description"];
  b06PrimaryButtonText?: B06Props["primaryButtonText"];
  b06PrimaryButtonLinkType?: B06Props["primaryButtonLinkType"];
  b06PrimaryButtonOpenInNewTab?: B06Props["primaryButtonOpenInNewTab"];
  b06PrimaryButtonOtherUrl?: B06Props["primaryButtonOtherUrl"];
  b06PrimaryButtonCategorySlug?: B06Props["primaryButtonCategorySlug"];
  b06SecondaryButtonText?: B06Props["secondaryButtonText"];
  b06SecondaryButtonLinkType?: B06Props["secondaryButtonLinkType"];
  b06SecondaryButtonOpenInNewTab?: B06Props["secondaryButtonOpenInNewTab"];
  b06SecondaryButtonOtherUrl?: B06Props["secondaryButtonOtherUrl"];
  b06SecondaryButtonCategorySlug?: B06Props["secondaryButtonCategorySlug"];
  b06MobileImg?: B06Props["mobileImg"];
  b06DesktopImg?: B06Props["desktopImg"];
  b06ImageAlt?: B06Props["imageAlt"];
  b06OverlayOpacity?: B06Props["overlayOpacity"];
}

export interface B07BannerProps {
  b07Eyebrow?: B07Props["eyebrow"];
  b07Heading?: B07Props["heading"];
  b07Subtext?: B07Props["subtext"];
  b07InputPlaceholder?: B07Props["inputPlaceholder"];
  b07MobileImg?: B07Props["mobileImg"];
  b07DesktopImg?: B07Props["desktopImg"];
  b07ImageAlt?: B07Props["imageAlt"];
  b07OverlayOpacity?: B07Props["overlayOpacity"];
}

export interface B08BannerProps {
  b08Heading?: B08Props["heading"];
  b08Description?: B08Props["description"];
  b08PrimaryButtonText?: B08Props["primaryButtonText"];
  b08PrimaryButtonLinkType?: B08Props["primaryButtonLinkType"];
  b08PrimaryButtonOpenInNewTab?: B08Props["primaryButtonOpenInNewTab"];
  b08PrimaryButtonOtherUrl?: B08Props["primaryButtonOtherUrl"];
  b08PrimaryButtonCategorySlug?: B08Props["primaryButtonCategorySlug"];
  b08SecondaryButtonText?: B08Props["secondaryButtonText"];
  b08SecondaryButtonLinkType?: B08Props["secondaryButtonLinkType"];
  b08SecondaryButtonOpenInNewTab?: B08Props["secondaryButtonOpenInNewTab"];
  b08SecondaryButtonOtherUrl?: B08Props["secondaryButtonOtherUrl"];
  b08SecondaryButtonCategorySlug?: B08Props["secondaryButtonCategorySlug"];
  b08MobileImg?: B08Props["mobileImg"];
  b08DesktopImg?: B08Props["desktopImg"];
  b08ImageAlt?: B08Props["imageAlt"];
}

export interface B09BannerProps {
  b09Heading?: B09Props["heading"];
  b09Description?: B09Props["description"];
  b09PrimaryButtonText?: B09Props["primaryButtonText"];
  b09PrimaryButtonLinkType?: B09Props["primaryButtonLinkType"];
  b09PrimaryButtonOpenInNewTab?: B09Props["primaryButtonOpenInNewTab"];
  b09PrimaryButtonOtherUrl?: B09Props["primaryButtonOtherUrl"];
  b09PrimaryButtonCategorySlug?: B09Props["primaryButtonCategorySlug"];
  b09SecondaryButtonText?: B09Props["secondaryButtonText"];
  b09SecondaryButtonLinkType?: B09Props["secondaryButtonLinkType"];
  b09SecondaryButtonOpenInNewTab?: B09Props["secondaryButtonOpenInNewTab"];
  b09SecondaryButtonOtherUrl?: B09Props["secondaryButtonOtherUrl"];
  b09SecondaryButtonCategorySlug?: B09Props["secondaryButtonCategorySlug"];
  b09MobileImg?: B09Props["mobileImg"];
  b09DesktopImg?: B09Props["desktopImg"];
  b09ImageAlt?: B09Props["imageAlt"];
}

export interface B10BannerProps {
  b10Heading?: B10Props["heading"];
  b10Description?: B10Props["description"];
  b10ButtonText?: B10Props["buttonText"];
  b10ButtonLinkType?: B10Props["buttonLinkType"];
  b10ButtonOpenInNewTab?: B10Props["buttonOpenInNewTab"];
  b10ButtonOtherUrl?: B10Props["buttonOtherUrl"];
  b10ButtonCategorySlug?: B10Props["buttonCategorySlug"];
  b10MobileImg?: B10Props["mobileImg"];
  b10DesktopImg?: B10Props["desktopImg"];
  b10ImageAlt?: B10Props["imageAlt"];
}

export interface B12BannerProps {
  b12Heading?: B12Props["heading"];
  b12Description?: B12Props["description"];
  b12PrimaryButtonText?: B12Props["primaryButtonText"];
  b12PrimaryButtonUrl?: B12Props["primaryButtonUrl"];
  b12SecondaryButtonText?: B12Props["secondaryButtonText"];
  b12SecondaryButtonUrl?: B12Props["secondaryButtonUrl"];
  b12MobileImg?: B12Props["mobileImg"];
  b12DesktopImg?: B12Props["desktopImg"];
  b12ImageAlt?: B12Props["imageAlt"];
}

export interface B13BannerProps {
  b13Heading?: B13Props["heading"];
  b13Description?: B13Props["description"];
  b13PrimaryButtonText?: B13Props["primaryButtonText"];
  b13PrimaryButtonUrl?: B13Props["primaryButtonUrl"];
  b13SecondaryButtonText?: B13Props["secondaryButtonText"];
  b13SecondaryButtonUrl?: B13Props["secondaryButtonUrl"];
  b13MobileImg?: B13Props["mobileImg"];
  b13DesktopImg?: B13Props["desktopImg"];
  b13ImageAlt?: B13Props["imageAlt"];
}

export interface B14BannerProps {
  b14Heading?: B14Props["heading"];
  b14Description?: B14Props["description"];
  b14PrimaryButtonText?: B14Props["primaryButtonText"];
  b14PrimaryButtonUrl?: B14Props["primaryButtonUrl"];
  b14Image?: B14Props["image"];
  b14ImageAlt?: B14Props["imageAlt"];
}

export interface B15BannerProps {
  b15Image?: B15Props["image"];
  b15ImageAlt?: B15Props["imageAlt"];
  b15LogoImage?: B15Props["logoImage"];
  b15LogoImageAlt?: B15Props["logoImageAlt"];
  b15PoweredByImage?: B15Props["poweredByImage"];
  b15PoweredByImageAlt?: B15Props["poweredByImageAlt"];
  b15Subtext?: B15Props["subtext"];
  b15InputPlaceholder?: B15Props["inputPlaceholder"];
}

export interface B16BannerProps {
  b16Eyebrow?: B16Props["eyebrow"];
  b16Heading?: B16Props["heading"];
  b16Description?: B16Props["description"];
  b16PrimaryButtonText?: B16Props["primaryButtonText"];
  b16PrimaryButtonUrl?: B16Props["primaryButtonUrl"];
  b16Image?: B16Props["image"];
  b16ImageAlt?: B16Props["imageAlt"];
}

export interface B17BannerProps {
  b17Heading?: B17Props["heading"];
  b17Description?: B17Props["description"];
  b17PrimaryButtonText?: B17Props["primaryButtonText"];
  b17PrimaryButtonUrl?: B17Props["primaryButtonUrl"];
  b17Image?: B17Props["image"];
  b17ImageAlt?: B17Props["imageAlt"];
}

export interface B18BannerProps {
  b18Heading?: B18Props["heading"];
  b18Description?: B18Props["description"];
  b18PrimaryButtonText?: B18Props["primaryButtonText"];
  b18PrimaryButtonUrl?: B18Props["primaryButtonUrl"];
  b18Image?: B18Props["image"];
  b18ImageAlt?: B18Props["imageAlt"];
}

export interface B19BannerProps {
  b19Heading?: B19Props["heading"];
  b19Description?: B19Props["description"];
  b19PrimaryButtonText?: B19Props["primaryButtonText"];
  b19PrimaryButtonUrl?: B19Props["primaryButtonUrl"];
  b19BackgroundVector?: B19Props["backgroundVector"];
}

export interface B20BannerProps {
  b20NewsletterTitle?: B20Props["newsletterTitle"];
  b20NewsletterPlaceholder?: B20Props["newsletterPlaceholder"];
  b20NewsletterButtonAriaLabel?: B20Props["newsletterButtonAriaLabel"];
  b20LogoImage?: B20Props["logoImage"];
  b20LogoImageAlt?: B20Props["logoImageAlt"];
  b20PrimaryButtonText?: B20Props["primaryButtonText"];
  b20PrimaryButtonUrl?: B20Props["primaryButtonUrl"];
  b20PoweredByImage?: B20Props["poweredByImage"];
  b20PoweredByImageAlt?: B20Props["poweredByImageAlt"];
  b20BackgroundVector?: B20Props["backgroundVector"];
}

export interface B21BannerProps {
  b21Heading?: B21Props["heading"];
  b21Description?: B21Props["description"];
  b21PrimaryButtonText?: B21Props["primaryButtonText"];
  b21PrimaryButtonUrl?: B21Props["primaryButtonUrl"];
  b21BackgroundVector?: B21Props["backgroundVector"];
  b21Watermark?: B21Props["watermark"];
}

export interface B22BannerProps {
  b22Heading?: B22Props["heading"];
  b22Description?: B22Props["description"];
  b22PrimaryButtonText?: B22Props["primaryButtonText"];
  b22PrimaryButtonUrl?: B22Props["primaryButtonUrl"];
  b22Image?: B22Props["image"];
  b22ImageAlt?: B22Props["imageAlt"];
}

export interface B23BannerProps {
  b23Heading?: B23Props["heading"];
  b23Description?: B23Props["description"];
}

export interface BannerProps
  extends B01BannerProps,
    B02BannerProps,
    B02bBannerProps,
    B03BannerProps,
    B04BannerProps,
    B05BannerProps,
    B06BannerProps,
    B07BannerProps,
    B08BannerProps,
    B09BannerProps,
    B10BannerProps,
    B12BannerProps,
    B13BannerProps,
    B14BannerProps,
    B15BannerProps,
    B16BannerProps,
    B17BannerProps,
    B18BannerProps,
    B19BannerProps,
    B20BannerProps,
    B21BannerProps,
    B22BannerProps,
    B23BannerProps {
  variant?: BannerVariant;
  backgroundColor?: string;
  id?: string;
  className?: string;
  linkRouteDefaults?: LinkRouteDefaults;
}

const Banner: React.FC<Readonly<BannerProps>> = (props) => {
  const { variant = B_01, linkRouteDefaults } = props;

  switch (variant) {
    case B_01: {
      const { listItems, backgroundColor, className } = props;

      return (
        <B01
          {...props}
          listItems={listItems}
          backgroundColor={backgroundColor}
          className={className}
        />
      );
    }

    case B_02: {
      const { b02Slides, sectionHeading, backgroundColor, id, className } = props;

      return (
        <B02
          slides={b02Slides}
          sectionHeading={sectionHeading}
          backgroundColor={backgroundColor}
          id={id}
          className={className}
        />
      );
    }

    case B_02b: {
      const { slides, backgroundColor, className } = props;

      return <B02b slides={slides} backgroundColor={backgroundColor} className={className} />;
    }

    case B_03: {
      const {
        b03EyebrowText,
        b03Heading,
        b03Features,
        b03CtaText,
        b03CtaLinkType,
        b03CtaOpenInNewTab,
        b03CtaOtherUrl,
        b03CtaCategorySlug,
        className,
      } = props;

      return (
        <B03
          eyebrowText={b03EyebrowText}
          heading={b03Heading}
          features={b03Features}
          ctaText={b03CtaText}
          ctaLinkType={b03CtaLinkType}
          ctaOpenInNewTab={b03CtaOpenInNewTab}
          ctaOtherUrl={b03CtaOtherUrl}
          ctaCategorySlug={b03CtaCategorySlug}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_04: {
      const {
        b04Eyebrow,
        b04Heading,
        b04Description,
        b04ButtonText,
        b04ButtonLinkType,
        b04ButtonOpenInNewTab,
        b04ButtonOtherUrl,
        b04ButtonCategorySlug,
        b04MobileImg,
        b04DesktopImg,
        b04ImageAlt,
        b04OverlayOpacity,
        className,
      } = props;

      return (
        <B04
          eyebrow={b04Eyebrow}
          heading={b04Heading}
          description={b04Description}
          buttonText={b04ButtonText}
          buttonLinkType={b04ButtonLinkType}
          buttonOpenInNewTab={b04ButtonOpenInNewTab}
          buttonOtherUrl={b04ButtonOtherUrl}
          buttonCategorySlug={b04ButtonCategorySlug}
          mobileImg={b04MobileImg}
          desktopImg={b04DesktopImg}
          imageAlt={b04ImageAlt}
          overlayOpacity={b04OverlayOpacity}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_05: {
      const {
        b05Heading,
        b05Description,
        b05BulletPoints,
        b05PrimaryButtonText,
        b05PrimaryButtonLinkType,
        b05PrimaryButtonOpenInNewTab,
        b05PrimaryButtonOtherUrl,
        b05PrimaryButtonCategorySlug,
        b05SecondaryButtonText,
        b05SecondaryButtonLinkType,
        b05SecondaryButtonOpenInNewTab,
        b05SecondaryButtonOtherUrl,
        b05SecondaryButtonCategorySlug,
        b05MobileImg,
        b05DesktopImg,
        b05ImageAlt,
        b05OverlayOpacity,
        className,
      } = props;

      return (
        <B05
          heading={b05Heading}
          description={b05Description}
          bulletPoints={b05BulletPoints}
          primaryButtonText={b05PrimaryButtonText}
          primaryButtonLinkType={b05PrimaryButtonLinkType}
          primaryButtonOpenInNewTab={b05PrimaryButtonOpenInNewTab}
          primaryButtonOtherUrl={b05PrimaryButtonOtherUrl}
          primaryButtonCategorySlug={b05PrimaryButtonCategorySlug}
          secondaryButtonText={b05SecondaryButtonText}
          secondaryButtonLinkType={b05SecondaryButtonLinkType}
          secondaryButtonOpenInNewTab={b05SecondaryButtonOpenInNewTab}
          secondaryButtonOtherUrl={b05SecondaryButtonOtherUrl}
          secondaryButtonCategorySlug={b05SecondaryButtonCategorySlug}
          mobileImg={b05MobileImg}
          desktopImg={b05DesktopImg}
          imageAlt={b05ImageAlt}
          overlayOpacity={b05OverlayOpacity}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_06: {
      const {
        b06Eyebrow,
        b06Heading,
        b06Description,
        b06PrimaryButtonText,
        b06PrimaryButtonLinkType,
        b06PrimaryButtonOpenInNewTab,
        b06PrimaryButtonOtherUrl,
        b06PrimaryButtonCategorySlug,
        b06SecondaryButtonText,
        b06SecondaryButtonLinkType,
        b06SecondaryButtonOpenInNewTab,
        b06SecondaryButtonOtherUrl,
        b06SecondaryButtonCategorySlug,
        b06MobileImg,
        b06DesktopImg,
        b06ImageAlt,
        b06OverlayOpacity,
        className,
      } = props;

      return (
        <B06
          eyebrow={b06Eyebrow}
          heading={b06Heading}
          description={b06Description}
          primaryButtonText={b06PrimaryButtonText}
          primaryButtonLinkType={b06PrimaryButtonLinkType}
          primaryButtonOpenInNewTab={b06PrimaryButtonOpenInNewTab}
          primaryButtonOtherUrl={b06PrimaryButtonOtherUrl}
          primaryButtonCategorySlug={b06PrimaryButtonCategorySlug}
          secondaryButtonText={b06SecondaryButtonText}
          secondaryButtonLinkType={b06SecondaryButtonLinkType}
          secondaryButtonOpenInNewTab={b06SecondaryButtonOpenInNewTab}
          secondaryButtonOtherUrl={b06SecondaryButtonOtherUrl}
          secondaryButtonCategorySlug={b06SecondaryButtonCategorySlug}
          mobileImg={b06MobileImg}
          desktopImg={b06DesktopImg}
          imageAlt={b06ImageAlt}
          overlayOpacity={b06OverlayOpacity}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_07: {
      const {
        b07Eyebrow,
        b07Heading,
        b07Subtext,
        b07InputPlaceholder,
        b07MobileImg,
        b07DesktopImg,
        b07ImageAlt,
        b07OverlayOpacity,
        className,
      } = props;

      return (
        <B07
          eyebrow={b07Eyebrow}
          heading={b07Heading}
          subtext={b07Subtext}
          inputPlaceholder={b07InputPlaceholder}
          mobileImg={b07MobileImg}
          desktopImg={b07DesktopImg}
          imageAlt={b07ImageAlt}
          overlayOpacity={b07OverlayOpacity}
          className={className}
        />
      );
    }

    case B_08: {
      const {
        b08Heading,
        b08Description,
        b08PrimaryButtonText,
        b08PrimaryButtonLinkType,
        b08PrimaryButtonOpenInNewTab,
        b08PrimaryButtonOtherUrl,
        b08PrimaryButtonCategorySlug,
        b08SecondaryButtonText,
        b08SecondaryButtonLinkType,
        b08SecondaryButtonOpenInNewTab,
        b08SecondaryButtonOtherUrl,
        b08SecondaryButtonCategorySlug,
        b08MobileImg,
        b08DesktopImg,
        b08ImageAlt,
        backgroundColor,
        className,
      } = props;

      return (
        <B08
          heading={b08Heading}
          description={b08Description}
          primaryButtonText={b08PrimaryButtonText}
          primaryButtonLinkType={b08PrimaryButtonLinkType}
          primaryButtonOpenInNewTab={b08PrimaryButtonOpenInNewTab}
          primaryButtonOtherUrl={b08PrimaryButtonOtherUrl}
          primaryButtonCategorySlug={b08PrimaryButtonCategorySlug}
          secondaryButtonText={b08SecondaryButtonText}
          secondaryButtonLinkType={b08SecondaryButtonLinkType}
          secondaryButtonOpenInNewTab={b08SecondaryButtonOpenInNewTab}
          secondaryButtonOtherUrl={b08SecondaryButtonOtherUrl}
          secondaryButtonCategorySlug={b08SecondaryButtonCategorySlug}
          mobileImg={b08MobileImg}
          desktopImg={b08DesktopImg}
          imageAlt={b08ImageAlt}
          backgroundColor={backgroundColor}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_09: {
      const {
        b09Heading,
        b09Description,
        b09PrimaryButtonText,
        b09PrimaryButtonLinkType,
        b09PrimaryButtonOpenInNewTab,
        b09PrimaryButtonOtherUrl,
        b09PrimaryButtonCategorySlug,
        b09SecondaryButtonText,
        b09SecondaryButtonLinkType,
        b09SecondaryButtonOpenInNewTab,
        b09SecondaryButtonOtherUrl,
        b09SecondaryButtonCategorySlug,
        b09MobileImg,
        b09DesktopImg,
        b09ImageAlt,
        backgroundColor,
        className,
      } = props;

      return (
        <B09
          heading={b09Heading}
          description={b09Description}
          primaryButtonText={b09PrimaryButtonText}
          primaryButtonLinkType={b09PrimaryButtonLinkType}
          primaryButtonOpenInNewTab={b09PrimaryButtonOpenInNewTab}
          primaryButtonOtherUrl={b09PrimaryButtonOtherUrl}
          primaryButtonCategorySlug={b09PrimaryButtonCategorySlug}
          secondaryButtonText={b09SecondaryButtonText}
          secondaryButtonLinkType={b09SecondaryButtonLinkType}
          secondaryButtonOpenInNewTab={b09SecondaryButtonOpenInNewTab}
          secondaryButtonOtherUrl={b09SecondaryButtonOtherUrl}
          secondaryButtonCategorySlug={b09SecondaryButtonCategorySlug}
          mobileImg={b09MobileImg}
          desktopImg={b09DesktopImg}
          imageAlt={b09ImageAlt}
          backgroundColor={backgroundColor}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_10: {
      const {
        b10Heading,
        b10Description,
        b10ButtonText,
        b10ButtonLinkType,
        b10ButtonOpenInNewTab,
        b10ButtonOtherUrl,
        b10ButtonCategorySlug,
        b10MobileImg,
        b10DesktopImg,
        b10ImageAlt,
        backgroundColor,
        className,
      } = props;

      return (
        <B10
          heading={b10Heading}
          description={b10Description}
          buttonText={b10ButtonText}
          buttonLinkType={b10ButtonLinkType}
          buttonOpenInNewTab={b10ButtonOpenInNewTab}
          buttonOtherUrl={b10ButtonOtherUrl}
          buttonCategorySlug={b10ButtonCategorySlug}
          mobileImg={b10MobileImg}
          desktopImg={b10DesktopImg}
          imageAlt={b10ImageAlt}
          backgroundColor={backgroundColor}
          className={className}
          linkRouteDefaults={linkRouteDefaults}
        />
      );
    }

    case B_12: {
      const {
        b12Heading,
        b12Description,
        b12PrimaryButtonText,
        b12PrimaryButtonUrl,
        b12SecondaryButtonText,
        b12SecondaryButtonUrl,
        b12MobileImg,
        b12DesktopImg,
        b12ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B12
          heading={b12Heading}
          description={b12Description}
          primaryButtonText={b12PrimaryButtonText}
          primaryButtonUrl={b12PrimaryButtonUrl}
          secondaryButtonText={b12SecondaryButtonText}
          secondaryButtonUrl={b12SecondaryButtonUrl}
          mobileImg={b12MobileImg}
          desktopImg={b12DesktopImg}
          imageAlt={b12ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_13: {
      const {
        b13Heading,
        b13Description,
        b13PrimaryButtonText,
        b13PrimaryButtonUrl,
        b13SecondaryButtonText,
        b13SecondaryButtonUrl,
        b13MobileImg,
        b13DesktopImg,
        b13ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B13
          heading={b13Heading}
          description={b13Description}
          primaryButtonText={b13PrimaryButtonText}
          primaryButtonUrl={b13PrimaryButtonUrl}
          secondaryButtonText={b13SecondaryButtonText}
          secondaryButtonUrl={b13SecondaryButtonUrl}
          mobileImg={b13MobileImg}
          desktopImg={b13DesktopImg}
          imageAlt={b13ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_14: {
      const {
        b14Heading,
        b14Description,
        b14PrimaryButtonText,
        b14PrimaryButtonUrl,
        b14Image,
        b14ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B14
          heading={b14Heading}
          description={b14Description}
          primaryButtonText={b14PrimaryButtonText}
          primaryButtonUrl={b14PrimaryButtonUrl}
          image={b14Image}
          imageAlt={b14ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_15: {
      const {
        b15Image,
        b15ImageAlt,
        b15LogoImage,
        b15LogoImageAlt,
        b15PoweredByImage,
        b15PoweredByImageAlt,
        b15Subtext,
        b15InputPlaceholder,
        backgroundColor,
        id,
      } = props;

      return (
        <B15
          image={b15Image}
          imageAlt={b15ImageAlt}
          logoImage={b15LogoImage}
          logoImageAlt={b15LogoImageAlt}
          poweredByImage={b15PoweredByImage}
          poweredByImageAlt={b15PoweredByImageAlt}
          subtext={b15Subtext}
          inputPlaceholder={b15InputPlaceholder}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_16: {
      const {
        b16Eyebrow,
        b16Heading,
        b16Description,
        b16PrimaryButtonText,
        b16PrimaryButtonUrl,
        b16Image,
        b16ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B16
          eyebrow={b16Eyebrow}
          heading={b16Heading}
          description={b16Description}
          primaryButtonText={b16PrimaryButtonText}
          primaryButtonUrl={b16PrimaryButtonUrl}
          image={b16Image}
          imageAlt={b16ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_17: {
      const {
        b17Heading,
        b17Description,
        b17PrimaryButtonText,
        b17PrimaryButtonUrl,
        b17Image,
        b17ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B17
          heading={b17Heading}
          description={b17Description}
          primaryButtonText={b17PrimaryButtonText}
          primaryButtonUrl={b17PrimaryButtonUrl}
          image={b17Image}
          imageAlt={b17ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_18: {
      const {
        b18Heading,
        b18Description,
        b18PrimaryButtonText,
        b18PrimaryButtonUrl,
        b18Image,
        b18ImageAlt,
        backgroundColor,
        id,
      } = props;

      return (
        <B18
          heading={b18Heading}
          description={b18Description}
          primaryButtonText={b18PrimaryButtonText}
          primaryButtonUrl={b18PrimaryButtonUrl}
          image={b18Image}
          imageAlt={b18ImageAlt}
          backgroundColor={backgroundColor}
          id={id}
        />
      );
    }

    case B_19: {
      const {
        b19Heading,
        b19Description,
        b19PrimaryButtonText,
        b19PrimaryButtonUrl,
        b19BackgroundVector,
        backgroundColor,
        className,
        id,
      } = props;

      return (
        <B19
          heading={b19Heading}
          description={b19Description}
          primaryButtonText={b19PrimaryButtonText}
          primaryButtonUrl={b19PrimaryButtonUrl}
          backgroundVector={b19BackgroundVector}
          backgroundColor={backgroundColor}
          className={className}
          id={id}
        />
      );
    }

    case B_20: {
      const {
        b20NewsletterTitle,
        b20NewsletterPlaceholder,
        b20NewsletterButtonAriaLabel,
        b20LogoImage,
        b20LogoImageAlt,
        b20PrimaryButtonText,
        b20PrimaryButtonUrl,
        b20PoweredByImage,
        b20PoweredByImageAlt,
        b20BackgroundVector,
        backgroundColor,
        className,
        id,
      } = props;

      return (
        <B20
          newsletterTitle={b20NewsletterTitle}
          newsletterPlaceholder={b20NewsletterPlaceholder}
          newsletterButtonAriaLabel={b20NewsletterButtonAriaLabel}
          logoImage={b20LogoImage}
          logoImageAlt={b20LogoImageAlt}
          primaryButtonText={b20PrimaryButtonText}
          primaryButtonUrl={b20PrimaryButtonUrl}
          poweredByImage={b20PoweredByImage}
          poweredByImageAlt={b20PoweredByImageAlt}
          backgroundVector={b20BackgroundVector}
          backgroundColor={backgroundColor}
          className={className}
          id={id}
        />
      );
    }

    case B_21: {
      const {
        b21Heading,
        b21Description,
        b21PrimaryButtonText,
        b21PrimaryButtonUrl,
        b21BackgroundVector,
        b21Watermark,
        backgroundColor,
        className,
        id,
      } = props;

      return (
        <B21
          heading={b21Heading}
          description={b21Description}
          primaryButtonText={b21PrimaryButtonText}
          primaryButtonUrl={b21PrimaryButtonUrl}
          backgroundVector={b21BackgroundVector}
          watermark={b21Watermark}
          backgroundColor={backgroundColor}
          className={className}
          id={id}
        />
      );
    }

    case B_22: {
      const {
        b22Heading,
        b22Description,
        b22PrimaryButtonText,
        b22PrimaryButtonUrl,
        b22Image,
        b22ImageAlt,
        backgroundColor,
        className,
        id,
      } = props;

      return (
        <B22
          heading={b22Heading}
          description={b22Description}
          primaryButtonText={b22PrimaryButtonText}
          primaryButtonUrl={b22PrimaryButtonUrl}
          image={b22Image}
          imageAlt={b22ImageAlt}
          backgroundColor={backgroundColor}
          className={className}
          id={id}
        />
      );
    }

    case B_23: {
      const { b23Heading, b23Description, className, id } = props;

      return (
        <B23 heading={b23Heading} description={b23Description} className={className} id={id} />
      );
    }

    default:
      return null;
  }
};

export default Banner;
